var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hoome"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 19.1513H9.7V13.2763H14.3V19.1513H18V10.1513L12 5.60132L6 10.1513V19.1513ZM5 20.1513V9.65132L12 4.35132L19 9.65132V20.1513H13.3V14.2763H10.7V20.1513H5Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMenuIcon);
export default __webpack_public_path__ + "static/media/home-menu-icon.b7dc98919c37331cb826933e08a11912.svg";
export { ForwardRef as ReactComponent };